import React from 'react'
import NoContent from "./NoContent";
import HomePage from "@system/config/home-page";
import CommonHomePageContent from "src/pages/HomePageContent/Common";
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';

const Videos = (props) => {
    const { videosList, searchText } = props;
    const typeHeadSearchEvent = (obj) => {
        HelperAnalyticsEvent.typeHeadSearchEvent(searchText, "Videos", obj?.name, obj?.url);
    }
    return (
        <>
            <div className="search-item-title text-uppercase">RECOMMENDED Videos</div>
            {Object.keys(videosList).length > 0 &&
                <>
                    <div className='search-product-list'>
                        {Object.keys(videosList).length > 0 && Object.entries(videosList).map((v, i) => (
                            <React.Fragment key={i}>
                                {
                                    i < 5 &&
                                    <div className='search-product-list-item'>
                                        <div className="search-product-list-item-info">
                                            <a onClick={() => typeHeadSearchEvent(v[1])} href={v[1].url} target="_blank" className="cursor-pointer ">
                                                <div className="search-product-list-item-title">
                                                    <div className="ellipses">{v[1].name}</div>
                                                </div>
                                            </a>
                                            <div className="search-product-list-item-subtitle">
                                                <div className="ellipses">{v[1].manufacturer}</div>
                                            </div>
                                            <div className="search-product-list-item-desc">
                                                {v[1].shortDescription}
                                            </div>
                                        </div>
                                    </div>
                                }
                            </React.Fragment>
                        ))}
                    </div>
                    <a href={HomePage.makeHomeTabsListRouteURL(CommonHomePageContent.chain_HomeTabList.CNT.param_value) + '&__c_HomePageContent=ALCT&__c_HomePageContentTabList=VDO&search=' + searchText + '&viewAll=true'}
                        className="text-center mt-auto pb-3 pt-3">
                        <div className="bs5 btn btn-sm btn-primary">VIEW ALL Video RESULtS</div>
                    </a>
                </>
            }
            {Object.keys(videosList).length === 0 &&
                <>
                    <NoContent />
                </>
            }
        </>
    )
}

export default Videos